import { Button, Card, Container } from "@mui/material";
import {
  DataGridPremium,
  GridColDef,
  GridRenderCellParams,
  GridToolbar,
  jaJP,
} from "@mui/x-data-grid-premium";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import AppContainer from "src/components/app/common/AppContainer";
import Iconify from "src/components/iconify";
import { useTrashCalendarListQuery } from "src/hooks/coreApi/useTrashCalendarListQuery";
import { TrashCalendarResponse } from "src/openapi";
import { PATH_DASHBOARD } from "src/routes/paths";

export default function TrashCalendarList() {
  const trashCalendarQuery = useTrashCalendarListQuery({});
  const trashCalendars = trashCalendarQuery?.data?.trashCalendars;

  const columns = useMemo<GridColDef[]>(() => {
    return [
      { field: "id", headerName: "ID" },
      {
        field: "name",
        width: 200,
        headerName: "名前",
        renderCell(
          params: GridRenderCellParams<string, TrashCalendarResponse>
        ) {
          return (
            <Link to={`/trashCalendars/${params.row.id}`}>{params.value}</Link>
          );
        },
      },
    ];
  }, []);

  return (
    <>
      <AppContainer
        meta={{
          title: "ゴミ出しカレンダー一覧",
        }}
        breadcrumbs={{
          heading: "ゴミ出しカレンダー一覧",
          links: [
            { name: "ホーム", href: PATH_DASHBOARD.root },
            { name: "ゴミ出しカレンダー" },
          ],
          action: (
            <>
              <Button
                component={Link}
                to="/trashCalendars/add"
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                新規追加
              </Button>
            </>
          ),
        }}
      >
        <Card style={{ height: "800px", width: "100%" }}>
          <DataGridPremium
            rows={trashCalendars || []}
            columns={columns}
            isRowSelectable={() => false}
            components={{ Toolbar: GridToolbar }}
            localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
            filterMode="client"
          />
        </Card>
      </AppContainer>
    </>
  );
}
